const article = {
    id: 'preset-change-request',
    title: 'Preset change request',
    summary: 'Pick the new preset, an optional model, and whether DD should be approved automatically when the request is approved.',
    publishedAt: '2026-09-24',
    tags: ['skus', 'requests'],
    sections: [
        {
            type: 'paragraph',
            text: 'A Preset Change request now records which angle preset the SKU should use, and optionally which model and occasion. On approval those are applied to the SKU. You can also auto-approve DD so the SKU does not wait at Assignment.',
        },
        { type: 'heading', text: 'When to use' },
        {
            type: 'paragraph',
            text: 'Use it when a SKU needs a different preset. Leave auto-approve DD off if Assignment should still review the preset and model. Turn it on when the choice is final and the SKU should move on as soon as the request is approved.',
        },
        { type: 'heading', text: 'How to use' },
        {
            type: 'steps',
            items: [
                'Open Skus, select one or more SKUs from the same client, and click Raise Request.',
                'Choose Preset Change. A mix of clients is blocked.',
                'Select New Preset. Angle thumbnails show the name and shoot type.',
                'Optionally select a model and occasion. A preview of that occasion is shown. The model becomes required if you turn on auto-approve DD.',
                'Tick Reshoot Required only when the files must be shot again.',
                'Tick Auto-approve DD after preset change only when DD should be approved as part of this request.',
                'Confirm. On the Requests page, the Preset / Model column shows the preset, model, reshoot, and Auto DD tags.',
            ],
        },
        { type: 'heading', text: 'What happens on approval' },
        {
            type: 'steps',
            items: [
                'Without auto-approve DD, the new preset and model are filled in and the SKU still waits for Assignment and DD review. If you did not pick a model, Assignment assigns one as before.',
                'With auto-approve DD and reshoot off, the SKU goes to Raw QC with the existing files.',
                'With auto-approve DD and reshoot on, the SKU goes to Shoot because the files must be taken again.',
            ],
        },
        {
            type: 'note',
            text: 'If the outbound box is already audited or outbounded, a reshoot on this request becomes a callback. Auto-approve DD is not applied on that outbound path.',
        },
    ],
};

export default article;
